import { SchemaWidgetInstance } from '../SchemaWidgetClass'

export const creativeWorkJson = (data: SchemaWidgetInstance, _page: unknown) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'CreativeWork',
    name: data.get('name'),
    description: data.get('description'),
    author: {
      '@type': 'Person',
      name: data.get('authorName'),
    },
    publisher: {
      '@type': 'Organization',
      name: data.get('organizationName'),
    },
    report: data.get('report'),
    techArticle: data.get('techArticle'),
    url: data.get('url'),
  }
}
